module.exports = __webpack_public_path__ + "static/logo_white-2e559bf16d58043830c9f8a584c15ae3.svg";